import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import HomeCard from '../../components/HomeCard/HomeCard';
import { useHistory } from 'react-router-dom';
import AuthContext from "../../authContext";
import firebase from 'firebase/app';

const useStyles = makeStyles({
  home: {
    width: '100%',
    height: 'calc(100% - 112px)',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '30px'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    color: 'rgb(55, 71, 172)'
  },
  inactive: {
    color: 'rgb(88, 101, 109)'
  },
});

const Home = () => {
  const classes = useStyles();
  const history = useHistory();
  const { currentUser } = useContext(AuthContext);
  const isLoggedIn = currentUser !== null;

  const support_business_text = (
    <>
      <p>
        Imagine waking up and going for a cup of coffee and a bagel at your local deli, only to find out it went out of business.
      </p>
      <p>
        The place used to be packed and you have known the owner since forever. You can prevent this from happening by lending them a hand in times of need.
      </p>
      <p>
        Just as they have been there for you when you needed them.
      </p>
    </>
  )

  const register_text = (
    <>
      <p>
        Are you a business owner affected by COVID-19? You know what steps you need to take in order to remain operational, but you that cash flow.
      </p>
      <p>
        You can set your goals and make them transparent to your customer base - so that they help you and know what they're helping you for.
        And in return, you can give them a voucher, as a thanks, so they can keep using your services in the future.
      </p>
    </>
  )

  const integrate_api_text = (
    <>
      <p>
        Read our API documentation and find out how to integrate it to
        your project to help us Fund the Future.
      </p>
    </>
  )

  const onFindBusinessesToSupportButtonClick = () => {
    history.push('/projects');
  };

  const onRegisterBusiness = () => {
    if (isLoggedIn) {
      history.push('/create');
    } else {
        const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(googleAuthProvider)
          .then(function(res) { history.push('/create'); });
    }
  };

  const onIntegrateAPI = () => {
    history.push('/docs')
  }

  return (
    <div className={classes.home}>
      <div className={classes.row}>
        <div className={classes.container}>
          <HomeCard
            title="Helping the community"
            text={support_business_text}
            button_text="Find businesses to support"
            button_hook={onFindBusinessesToSupportButtonClick}
            className={classes.card}
          />
          <HomeCard
            title="Register your business"
            text={register_text}
            button_text="Register business"
            button_hook={onRegisterBusiness}
            className={classes.card}
          />
        </div>

      </div>

      <div className={classes.row}>
        <HomeCard
          title="Integrate with our API"
          text={integrate_api_text}
          button_text="API documentation"
          button_hook={onIntegrateAPI}
          className={classes.card}
        />
      </div>

    </div>

  );
};

export default Home;
